import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { FilterListService, GungListModule } from 'gung-list';
import {
  BackendInterceptor,
  CartConfigService,
  CustomerService,
  UsersService,
  CheckoutConfigService,
  createTranslateLocalLoader,
  CustomerListConfigService,
  GungStandardModule,
  HomeNavigationConfigService,
  LanguageConfigService,
  ProductExportActionConfigService,
  ProductListConfigService,
  SalesCartConfigService,
  TranslationLocalService,
  PriceConfigService,
  SavedQuoteTableService,
  OrderListConfigService,
  ProductExportListConfigService,
  PimListConfigService,
  PriceService,
  ProductService,
  CartsService,
  SavedCartConfigService,
  SavedQuoteConfigService,
  OpenOrdersConfigService,
  ProductListByIdsConfigService,
  LoginConfigService,
  GungTitleService,
  GungNavbarService,
  GungMainMenuService,
  InvoiceCardListComponent,
  CustomerContactListConfigService,
  UsersDetailsCustomersListConfigService,
  NewsActionConfigService,
  UsersListConfigService
} from 'gung-standard';
import {
  GungStandardJeevesModule,
  JeevesCustomerActionConfigService,
  JeevesInvoiceActionConfigService,
  JeevesInvoiceCardListComponent,
  JeevesInvoiceListConfigService,
  JeevesModalService,
  JeevesProductListConfigService,
  JeevesCustomerListConfigService,
  JeevesCustomerContactListConfigService
} from 'gung-standard-jeeves';
import { environment } from '../environments/environment';
import { AppComponent } from './car-liner-app.component';
import { CarLinerBackendInterceptorService } from './services/car-liner-backend-interceptor.service';
import { CarLinerTranslationLocalService } from './services/car-liner-translation-local.service';
import { CarLinerAppWrapperComponent } from './components/car-liner-app-wrapper/car-liner-app-wrapper.component';
import { CarLinerNavbarComponent } from './components/car-liner-navbar/car-liner-navbar.component';
import { CarLinerGungNavbarService } from './services/car-liner-gung-navbar.service';
import { CarLinerGungMainMenuService } from './services/car-liner-gung-main-menu.service';
import { CarLinerSalesCartListComponent } from './components/car-liner-sales-cart-list/car-liner-sales-cart-list.component';
import { CarLinerSalesCartConfigService } from './services/car-liner-sales-cart-config.service';
import { CarLinerCartConfigService } from './services/car-liner-cart-config.service';
import { CarLinerButtonsComponent } from './components/car-liner-buttons/car-liner-buttons.component';
import { CarLinerCheckoutConfigService } from './services/car-liner-checkout-config.service';
import { CarLinerLanguageConfigService } from './services/car-liner-language-config.service';
import { CarLinerHomeNavigationConfigService } from './services/car-liner-home-navigation-config.service';
import { CarLinerProductListConfigService } from './services/car-liner-product-list-config.service';
import { CarLinerProductTableComponent } from './components/car-liner-product-table/car-liner-product-table.component';
import { CarLinerProductDetailsComponent } from './components/car-liner-product-details/car-liner-product-details.component';
import { CarLinerProductGridViewComponent } from './components/car-liner-product-grid-view/car-liner-product-grid-view.component';
import { CarLinerPimProductComponent } from './components/pim/car-liner-pim-product/car-liner-pim-product.component';
import { CarLinerCreateQuotationModalComponent } from './components/car-liner-create-quotation-modal/car-liner-create-quotation-modal.component';
import { CarLinerSaveCartModalConfigService } from './services/car-liner-save-cart-modal-config.service';
import { SaveCartModalConfigService } from 'gung-standard';
import { CarLinerPdfDownloadIndicatorComponent } from './components/car-liner-pdf-download-indicator/car-liner-pdf-download-indicator.component';
import { CarLinerIncludedItemsByIdsComponent } from './components/car-liner-included-items-by-ids/car-liner-included-items-by-ids.component';
import { CarLinerIncludedItemsGridViewComponent } from './components/car-liner-included-items-grid-view/car-liner-included-items-grid-view.component';
import { CarLinerModalService } from './services/car-liner-modal.service';
import { CarLinerIncludedItemsModalComponent } from './components/car-liner-included-items-modal/car-liner-included-items-modal.component';
import { CarLinerProductExportActionConfigService } from './services/car-liner-product-export-action-config.service';
import { CommonModalService, DocumentTemplatesService, GungCommonModule } from 'gung-common';
import { CarLinerUsersService } from './services/car-liner-users.service';
import { CarLinerOrderDetailsComponent } from './components/car-liner-order-details/car-liner-order-details.component';
import { CarLinerPriceConfigService } from './services/car-liner-price-config.service';
import { CarLinerSavedQuoteTableService } from './services/car-liner-saved-quote-table.service';
import { CarLinerOrderListConfigService } from './services/car-liner-order-list-config.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarLinerFilterListService } from './services/car-liner-filter-list.service';
import { CarLinerProductExportListConfigService } from './services/car-liner-product-export-list-config.service';
import { CarLinerCustomerActionConfigService } from './services/car-liner-customer-action-config.service';
import { CarLinerPimListConfigService } from './services/car-liner-pim-list-config.service';
import { CarLinerPimProductBasicInfoComponent } from './components/pim/car-liner-pim-product-basic-info/car-liner-pim-product-basic-info.component';
import { CarLinerOrderCardListComponent } from './components/car-liner-order-card-list/car-liner-order-card-list.component';
import { CarLinerMysetupModalComponent } from './components/car-liner-mysetup-modal/car-liner-mysetup-modal.component';
import { CarLinerPriceService } from './services/car-liner-price.service';
import { CarLinerProductService } from './services/car-liner-product.service';
import { CarLinerCartService } from './services/car-liner-cart.service';
import { CarLinerCheckoutAddRowModalComponent } from './components/car-liner-checkout-add-row-modal/car-liner-checkout-add-row-modal.component';
import { CarLinerSavedQuoteTableComponent } from './components/car-liner-saved-quote-table/car-liner-saved-quote-table.component';
import { CarLinerSavedCartTableComponent } from './components/car-liner-saved-cart-table/car-liner-saved-cart-table.component';
import { CarLinerSavedCartConfigService } from './services/car-liner-saved-cart-config.service';
import { CarLinerSavedQuoteConfigService } from './services/car-liner-saved-quote-config.service';
import { CarLinerUserDetailsComponent } from './components/car-liner-user-details/car-liner-user-details.component';
import { CarLinerUserDetailsUserComponent } from './components/car-liner-user-details/car-liner-user-details-user/car-liner-user-details-user.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CarLinerOpenOrdersTableComponent } from './components/car-liner-open-orders-table/car-liner-open-orders-table.component';
import { CarLinerOpenOrderConfigService } from './services/car-liner-open-order-config.service';
import { CarLinerPriceComponent } from './components/car-liner-price/car-liner-price.component';
import { CarLinerProductListByIdsConfigService } from './services/car-liner-product-list-by-ids-config.service';
import { CarLinerProductListByIdsComponent } from './components/car-liner-product-list-by-ids/car-liner-product-list-by-ids.component';
import { CarLinerDeliveryLocationsJeevesComponent } from './components/car-liner-delivery-locations-jeeves/car-liner-delivery-locations-jeeves.component';
import { CarLinerRemoveBlockedProductsStepComponent } from './components/car-liner-remove-blocked-products-step/car-liner-remove-blocked-products-step.component';
import { CarLinerCustomerDetailsComponent } from './components/car-liner-customer-details/car-liner-customer-details.component';
import { CarLinerPimProductPowerUnitsComponent } from './components/pim/car-liner-pim-product-power-units/car-liner-pim-product-power-units.component';
import { CarLinerBrochuresAddModalComponent } from './components/car-liner-brochures-add-modal/car-liner-brochures-add-modal.component';
import { CarLinerBrochuresProductListViewComponent } from './components/car-liner-brochures-product-list-view/car-liner-brochures-product-list-view.component';
import { CarLinerLoginComponent } from './components/car-liner-login/car-liner-login.component';
import { CarLinerLoginConfigService } from './services/car-liner-login-config.service';
import { CarLinerJeevesInvoiceActionConfigService } from './services/car-liner-jeeves-invoice-action-config.service';
import { CarLinerGungTitleService } from './services/car-liner-gung-title.service';
import { CarLinerDocumentTemplatesService } from './services/car-liner-document-templates.service';
import { DashboardCardService } from 'gung-dashboard';
import { CarLinerDashboardCardService } from './services/car-liner-dashboard-card.service';
import { CarLinerSalesSummaryCardComponent } from './components/car-liner-sales-summary-card/car-liner-sales-summary-card.component';
import { CarLinerPimProductSparePartsComponent } from './components/pim/car-liner-pim-product-spare-parts/car-liner-pim-product-spare-parts.component';
import { CarLinerIncludedItemsTableComponent } from './components/car-liner-included-items-table/car-liner-included-items-table.component';
import { CarLinerInvoiceCardListComponent } from './components/car-liner-invoice-card-list/car-liner-invoice-card-list.component';
import { CarLinerInvoiceListConfigService } from './services/car-liner-invoice-list-config.service';
import { CarLinerCustomerListCardComponent } from './components/car-liner-customer-list-card/car-liner-customer-list-card.component';
import { CarLinerCustomerListConfigService } from './services/car-liner-customer-list-config.service';
import { CarLinerCustomerContactCardListComponent } from './components/car-liner-customer-contact-card-list/car-liner-customer-contact-card-list.component';
import { CarLinerCustomerContactListConfigService } from './services/car-liner-customer-contact-list-config.service';
import { CarLinerUsersDetailsCustomersListConfigService } from './services/car-liner-users-details-customers-list-config.service';
import { CarLinerForgotPasswordComponent } from './components/car-liner-forgot-password/car-liner-forgot-password.component';
import { CarLinerNewsActionConfigService } from './services/car-liner-news-action-config.service';
import { CarLinerUsersListConfigService } from './services/car-liner-users-list-config.service';
import { CarLinerUserTableComponent } from './components/car-liner-user-table/car-liner-user-table.component';
import { CarLinerUserDetailsCustomersComponent } from './components/car-liner-user-details/car-liner-user-details-customers/car-liner-user-details-customers.component';
import { CarLinerCustomerService } from './services/car-liner-customer.service';

@NgModule({
  declarations: [
    AppComponent,
    CarLinerAppWrapperComponent,
    CarLinerNavbarComponent,
    CarLinerSalesCartListComponent,
    CarLinerButtonsComponent,
    CarLinerProductTableComponent,
    CarLinerProductDetailsComponent,
    CarLinerProductGridViewComponent,
    CarLinerPimProductComponent,
    CarLinerCreateQuotationModalComponent,
    CarLinerPdfDownloadIndicatorComponent,
    CarLinerIncludedItemsByIdsComponent,
    CarLinerIncludedItemsGridViewComponent,
    CarLinerIncludedItemsModalComponent,
    CarLinerOrderDetailsComponent,
    CarLinerPimProductBasicInfoComponent,
    CarLinerOrderCardListComponent,
    CarLinerMysetupModalComponent,
    CarLinerCheckoutAddRowModalComponent,
    CarLinerSavedQuoteTableComponent,
    CarLinerSavedCartTableComponent,
    CarLinerUserDetailsComponent,
    CarLinerUserDetailsUserComponent,
    CarLinerOpenOrdersTableComponent,
    CarLinerPriceComponent,
    CarLinerProductListByIdsComponent,
    CarLinerDeliveryLocationsJeevesComponent,
    CarLinerRemoveBlockedProductsStepComponent,
    CarLinerCustomerDetailsComponent,
    CarLinerPimProductPowerUnitsComponent,
    CarLinerBrochuresAddModalComponent,
    CarLinerBrochuresProductListViewComponent,
    CarLinerLoginComponent,
    CarLinerSalesSummaryCardComponent,
    CarLinerPimProductSparePartsComponent,
    CarLinerIncludedItemsTableComponent,
    CarLinerInvoiceCardListComponent,
    CarLinerCustomerListCardComponent,
    CarLinerCustomerContactCardListComponent,
    CarLinerForgotPasswordComponent,
    CarLinerUserDetailsCustomersComponent,
    CarLinerUserTableComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    GungCommonModule,
    GungListModule,
    GungStandardModule,
    GungStandardJeevesModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    RouterModule,
    DragDropModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLocalLoader,
        deps: [TranslationLocalService]
      }
    })
  ],
  providers: [
    { provide: 'environment', useValue: environment },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CarLinerBackendInterceptorService,
      multi: true
    },
    {
      provide: BackendInterceptor,
      useClass: CarLinerBackendInterceptorService
    },
    {
      provide: TranslationLocalService,
      useClass: CarLinerTranslationLocalService
    },
    {
      provide: GungNavbarService,
      useClass: CarLinerGungNavbarService
    },
    {
      provide: GungMainMenuService,
      useClass: CarLinerGungMainMenuService
    },
    {
      provide: SalesCartConfigService,
      useClass: CarLinerSalesCartConfigService
    },
    {
      provide: CartConfigService,
      useClass: CarLinerCartConfigService
    },
    {
      provide: CheckoutConfigService,
      useClass: CarLinerCheckoutConfigService
    },
    {
      provide: LanguageConfigService,
      useClass: CarLinerLanguageConfigService
    },
    {
      provide: HomeNavigationConfigService,
      useClass: CarLinerHomeNavigationConfigService
    },
    {
      provide: ProductListConfigService,
      useClass: CarLinerProductListConfigService
    },
    {
      provide: JeevesProductListConfigService,
      useClass: CarLinerProductListConfigService
    },
    {
      provide: SaveCartModalConfigService,
      useClass: CarLinerSaveCartModalConfigService
    },
    {
      provide: JeevesModalService,
      useClass: CarLinerModalService
    },
    {
      provide: ProductExportActionConfigService,
      useClass: CarLinerProductExportActionConfigService
    },
    {
      provide: UsersService,
      useClass: CarLinerUsersService
    },
    {
      provide: PriceConfigService,
      useClass: CarLinerPriceConfigService
    },
    {
      provide: SavedQuoteTableService,
      useClass: CarLinerSavedQuoteTableService
    },
    {
      provide: OrderListConfigService,
      useClass: CarLinerOrderListConfigService
    },
    {
      provide: FilterListService,
      useClass: CarLinerFilterListService
    },
    {
      provide: ProductExportListConfigService,
      useClass: CarLinerProductExportListConfigService
    },
    {
      provide: JeevesCustomerActionConfigService,
      useClass: CarLinerCustomerActionConfigService
    },
    {
      provide: PimListConfigService,
      useClass: CarLinerPimListConfigService
    },
    {
      provide: PriceService,
      useClass: CarLinerPriceService
    },
    {
      provide: ProductService,
      useExisting: CarLinerProductService
    },
    // { commented because it was breaking the checkout cart (not always, didn't found a pattern)
    //   provide: CartsService,
    //   useClass: CarLinerCartService
    // },
    {
      provide: SavedCartConfigService,
      useClass: CarLinerSavedCartConfigService
    },
    {
      provide: SavedQuoteConfigService,
      useClass: CarLinerSavedQuoteConfigService
    },
    {
      provide: OpenOrdersConfigService,
      useClass: CarLinerOpenOrderConfigService
    },
    {
      provide: ProductListByIdsConfigService,
      useClass: CarLinerProductListByIdsConfigService
    },
    {
      provide: LoginConfigService,
      useClass: CarLinerLoginConfigService
    },
    {
      provide: JeevesInvoiceActionConfigService,
      useClass: CarLinerJeevesInvoiceActionConfigService
    },
    {
      provide: GungTitleService,
      useClass: CarLinerGungTitleService
    },
    {
      provide: DocumentTemplatesService,
      useClass: CarLinerDocumentTemplatesService
    },
    {
      provide: DashboardCardService,
      useClass: CarLinerDashboardCardService
    },
    {
      provide: JeevesInvoiceListConfigService,
      useClass: CarLinerInvoiceListConfigService
    },
    {
      provide: JeevesInvoiceListConfigService,
      useClass: CarLinerInvoiceListConfigService
    },
    {
      provide: CustomerService,
      useClass: CarLinerCustomerService
    },
    {
      provide: CustomerListConfigService,
      useClass: CarLinerCustomerListConfigService
    },
    {
      provide: CustomerContactListConfigService,
      useClass: CarLinerCustomerContactListConfigService
    },
    {
      provide: JeevesCustomerContactListConfigService,
      useClass: CarLinerCustomerContactListConfigService
    },
    {
      provide: JeevesCustomerListConfigService,
      useClass: CarLinerCustomerListConfigService
    },
    {
      provide: UsersDetailsCustomersListConfigService,
      useClass: CarLinerUsersDetailsCustomersListConfigService
    },
    {
      provide: NewsActionConfigService,
      useClass: CarLinerNewsActionConfigService
    },
    {
      provide: UsersListConfigService,
      useClass: CarLinerUsersListConfigService
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule { }